export const resultCustomCodes = {
  BLOCKED: 'Blocked'
}
